import {
    ApiComponentType,
    ApiIncidentType,
    ComponentStatusEnum,
    IncidentLevelEnum,
    IncidentType,
} from "@store/types";

export const compareIncidentByLevel = (a: IncidentType, b: IncidentType): number =>
    a.index - b.index;

const hasStatus = (
    components: ApiComponentType[],
    status: ComponentStatusEnum,
    componentIds?: string[],
): boolean => {
    return components.some(
        (c) => c.status === status && (!componentIds || componentIds.includes(c.id)),
    );
};

const getIncidentLevel = ({ components }: IncidentType | ApiIncidentType): IncidentLevelEnum => {
    switch (true) {
        case components.every((c) => c.status === ComponentStatusEnum.OPERATIONAL): {
            return IncidentLevelEnum.SUCCESS;
        }
        case hasStatus(components, ComponentStatusEnum.MAJOR_OUTAGE): {
            return IncidentLevelEnum.DANGER;
        }
        default: {
            return IncidentLevelEnum.WARNING;
        }
    }
};

export const mapApiIncidentToIncident = (
    incident: ApiIncidentType,
    index: number,
): IncidentType => ({
    components: incident.components,
    description: incident.incident_updates[0]?.body || "",
    id: incident.id,
    level: getIncidentLevel(incident),
    name: incident.name,
    updatedAt: incident.updated_at,
    index: index,
});
